import React from "react";
import { useSelector } from "react-redux";
import { Grid, Header, Segment, List } from "semantic-ui-react";
import { GamButtons } from "../utils/buttons";
import { AdServeData } from "../../banner/ad-data";

const Info = () => {
  const banner = useSelector((state) => state.banner);
  const user = useSelector((state) => state.user);
  return (
    <>
      <Grid padded className="brand-info">
        {user && banner.adServeData && (
          <Grid.Row>
            <Grid.Column computer={16} tablet={16} mobile={16}>
              <AdServeData data={banner.adServeData} />
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Banner info</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>Title</List.Header>
                    {banner.bannerTitle}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Ad number</List.Header>
                    {banner.adNumber}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Advertiser</List.Header>
                    {banner.advertiser}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Banner link</List.Header>
                    {banner.bannerURL}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Tesco event</List.Header>
                    {banner.tescoEvent}
                  </List.Content>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Banner text</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>ALT text</List.Header>
                    {banner.alt}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Hide MPU?</List.Header>
                    {banner.hideMPU}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Open link option</List.Header>
                    {banner.openLinkOptions}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Information banner?</List.Header>
                    {banner.informationBanner}
                  </List.Content>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={8} tablet={16} mobile={16}>
            <Header as="h3">Images</Header>
            <List divided celled size="medium" className="bm-brand-img-list">
              {banner.mobile375x110 && banner.mobile375x110.path && (
                <List.Item>
                  <List.Content>
                    <List.Header>
                      Mobile {banner.mobile375x110.size}
                    </List.Header>
                    <img src={banner.mobile375x110.path} alt={banner.alt} />
                    <span>{banner.mobile375x110.name}</span>
                  </List.Content>
                </List.Item>
              )}
              {banner.mobile375x258 && banner.mobile375x258.path && (
                <List.Item>
                  <List.Content>
                    <List.Header>
                      Mobile MPU {banner.mobile375x258.size}
                    </List.Header>
                    <img src={banner.mobile375x258.path} alt={banner.alt} />
                    <span>{banner.mobile375x258.name}</span>
                  </List.Content>
                </List.Item>
              )}
              {banner.tablet532x110 && banner.tablet532x110.path && (
                <List.Item>
                  <List.Content>
                    <List.Header>
                      Tablet {banner.tablet532x110.size}
                    </List.Header>
                    <img src={banner.tablet532x110.path} alt={banner.alt} />
                    <span>{banner.tablet532x110.name}</span>
                  </List.Content>
                </List.Item>
              )}
              {banner.tablet724x110 && banner.tablet724x110.path && (
                <List.Item>
                  <List.Content>
                    <List.Header>
                      Laptop {banner.tablet724x110.size}
                    </List.Header>
                    <img src={banner.tablet724x110.path} alt={banner.alt} />
                    <span>{banner.tablet724x110.name}</span>
                  </List.Content>
                </List.Item>
              )}
              {banner.desktop918x110 && banner.desktop918x110.path && (
                <List.Item>
                  <List.Content>
                    <List.Header>
                      Desktop {banner.desktop918x110.size}
                    </List.Header>
                    <img src={banner.desktop918x110.path} alt={banner.alt} />
                    <span>{banner.desktop918x110.name}</span>
                  </List.Content>
                </List.Item>
              )}
              {banner.widedesktop984x120wide &&
                banner.widedesktop984x120.path && (
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Desktop dotcom {banner.widedesktop984x120.size}
                      </List.Header>
                      <img
                        src={banner.widedesktop984x120.path}
                        alt={banner.alt}
                      />
                      <span>{banner.widedesktop984x120.name}</span>
                    </List.Content>
                  </List.Item>
                )}
              {banner.widedesktop1486x120 &&
                banner.widedesktop1486x120.path && (
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Desktop dotcom wide {banner.widedesktop1486x120.size}
                      </List.Header>
                      <img
                        src={banner.widedesktop1486x120.path}
                        alt={banner.alt}
                      />
                      <span>{banner.widedesktop1486x120.name}</span>
                    </List.Content>
                  </List.Item>
                )}
              {banner.widedesktop1486x180 &&
                banner.widedesktop1486x180.path && (
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Desktop dotcom (old) {banner.widedesktop1486x180.size}
                      </List.Header>
                      <img
                        src={banner.widedesktop1486x180.path}
                        alt={banner.alt}
                      />
                      <span>{banner.widedesktop1486x180.name}</span>
                    </List.Content>
                  </List.Item>
                )}
              {banner.buylistHeader && banner.buylistHeader.path && (
                <List.Item>
                  <List.Content>
                    <List.Header>
                      Buylist header {banner.buylistHeader.size}
                    </List.Header>
                    <img src={banner.buylistHeader.path} alt={banner.alt} />
                    <span>{banner.buylistHeader.name}</span>
                  </List.Content>
                </List.Item>
              )}
            </List>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {user && user.isAdOps && <GamButtons banner={banner} service="gam" />}
    </>
  );
};

export default Info;
